<template>
  <section class="page-interaction">
    <b-overlay :show="loading" no-center variant="transparent" rounded="sm">
      <template #overlay>
        <loading-spinner />
      </template>
      <div v-if="!userCanStartVideoCall">
        <b-row v-for="(call, i) in voiceCalls" :key="i">
          <call-card :call="call" :call-type="isVideoCall(call) ? 'video' : 'voice'" @setLoading="setLoading($event)"/>
        </b-row>
        <b-row v-if="!loading && voiceCalls.length < 1">
          <discover-no-user>
            <h3 class="color-black">
              {{ $t('No one in the call log yet') }}
            </h3>
          </discover-no-user>
        </b-row>
      </div>
      <b-tabs v-else content-class="mt-3" v-model="activeTabIndex">
<!--        <b-tab :title="`${$t('All')} (${successCalls.length})`">-->
<!--          <b-row v-for="(call, i) in successCalls" :key="i">-->
<!--            <call-card :call="call" @setLoading="setLoading($event)"/>-->
<!--          </b-row>-->
<!--          <b-row v-if="!loading && successCalls.length < 1">-->
<!--            <discover-no-user>-->
<!--              <h3 class="color-black">-->
<!--                {{ $t('No one in the call log yet') }}-->
<!--              </h3>-->
<!--            </discover-no-user>-->
<!--          </b-row>-->
<!--        </b-tab>-->
<!--        <b-tab :title="`${$t('Missed calls')} (${failedCalls.length})`">-->
<!--          <b-row v-for="(call, i) in failedCalls" :key="i">-->
<!--            <call-card :call="call" @setLoading="setLoading($event)" hide-time/>-->
<!--          </b-row>-->
<!--          <b-row v-if="!loading && failedCalls.length < 1">-->
<!--            <discover-no-user>-->
<!--              <h3 class="color-black">-->
<!--                {{ $t('No one in the missed call log') }}-->
<!--              </h3>-->
<!--            </discover-no-user>-->
<!--          </b-row>-->
<!--        </b-tab>-->
        <b-tab>
          <template v-if="userCanStartVideoCall" v-slot:title>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22 10.4197H19.6842C19.6842 5.72338 16.2708 2.31575 11.5675 2.31575V0C17.5155 0 22 4.47982 22 10.4197ZM15.0527 10.4209C15.0527 7.98587 14.0141 6.94725 11.5791 6.94725V4.6315C15.3132 4.6315 17.3685 6.68673 17.3685 10.4209H15.0527ZM14.726 12.9488C15.0265 12.9395 15.3189 13.0474 15.5413 13.2496L20.247 17.5291C20.4699 17.7318 20.6049 18.0135 20.6235 18.3142C20.6421 18.6149 20.5428 18.911 20.3465 19.1397L18.1929 21.6534C17.993 21.8545 17.7257 21.9745 17.4426 21.9904C17.4044 21.9927 17.2608 21.9996 17.0269 21.9996C15.4267 21.9996 9.61649 21.6604 4.97804 17.0231C-0.338931 11.7038 -0.00777867 4.84686 0.00958948 4.55739C0.0257066 4.27424 0.14519 4.00684 0.345374 3.80593L2.85797 1.65112C3.08676 1.45505 3.38298 1.35588 3.68371 1.37469C3.98444 1.3935 4.26599 1.5288 4.46857 1.75186L8.74693 6.45631C8.94942 6.67867 9.05746 6.97109 9.04816 7.2717C9.03887 7.5723 8.91298 7.85749 8.69714 8.06692L5.84992 10.8389C5.97381 11.5012 6.39181 12.8455 7.772 14.2268C9.15218 15.6035 10.493 16.0215 11.1599 16.1489L13.9307 13.2994C14.1403 13.0838 14.4255 12.9581 14.726 12.9488Z" fill="#10B063"/>
            </svg>
            {{ $t('With Voice') }} ({{ voiceCalls.length }})
          </template>
          <b-row v-for="(call, i) in voiceCalls" :key="i">
            <call-card :call="call" :call-type="isVideoCall(call) ? 'video' : 'voice'" @setLoading="setLoading($event)"/>
          </b-row>
          <b-row v-if="!loading && voiceCalls.length < 1">
            <discover-no-user>
              <h3 class="color-black">
                {{ $t('No one in the call log yet') }}
              </h3>
            </discover-no-user>
          </b-row>
        </b-tab>
        <b-tab v-if="userCanStartVideoCall">
          <template v-slot:title>
            <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.73195 14.2635C2.24434 14.2635 1.82707 14.09 1.48014 13.7431C1.1332 13.3961 0.959438 12.9786 0.958847 12.4904V1.85177C0.958847 1.36417 1.13261 0.946902 1.48014 0.599965C1.82767 0.253029 2.24494 0.0792653 2.73195 0.0786743H13.3705C13.8581 0.0786743 14.2757 0.252438 14.6232 0.599965C14.9708 0.947493 15.1442 1.36476 15.1436 1.85177V5.84125L17.9363 3.04862C18.084 2.90086 18.2466 2.86392 18.4239 2.9378C18.6012 3.01168 18.6898 3.15205 18.6898 3.35891V10.9832C18.6898 11.1901 18.6012 11.3305 18.4239 11.4043C18.2466 11.4782 18.084 11.4413 17.9363 11.2935L15.1436 8.5009V12.4904C15.1436 12.978 14.9702 13.3955 14.6232 13.7431C14.2763 14.0906 13.8587 14.2641 13.3705 14.2635H2.73195Z" fill="#DB34F3"/>
            </svg>
            {{ $t('With Video') }} ({{ videoCalls.length }})
          </template>
          <b-row v-for="(call, i) in videoCalls" :key="i">
            <call-card :call="call" call-type="video" @setLoading="setLoading($event)"/>
          </b-row>
          <b-row v-if="!loading && videoCalls.length < 1">
            <discover-no-user>
              <h3 class="color-black">
                {{ $t('No one in the call log yet') }}
              </h3>
            </discover-no-user>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-overlay>
  </section>
</template>

<script>
import {
  BOverlay, BRow, BTabs, BTab,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { isVideoCall, showNotify, throwDefaultError } from '@/helpers/helpers'
import DiscoverNoUser from '@/components/DiscoverNoUser'
import CallCard from '@/components/CallCard'
import { avatarText } from '@core/utils/filter'
import moment from 'moment'

const iconPhone = require('@/assets/images/icons/phone-green.svg')

// import { getUser } from '@/auth/utils'

export default {
  name: 'CallsIndex',
  components: {
    BOverlay,
    BRow,
    BTabs,
    BTab,

    CallCard,
    DiscoverNoUser,
  },
  data() {
    return {
      activeTabIndex: 0,
      calls: [],
      limit: 300,
      loading: false,
      failedCalls: [],
      iconPhone,
      successCalls: [],
    }
  },
  computed: {
    missedCalls() {
      return this.calls.filter(call => call.callStatus === 'no_answer')
    },
    successfulCalls() {
      return this.calls.filter(call => call.callStatus === 'completed' || call.callStatus === 'canceled')
    },
    userCanStartVideoCall() {
      return this.$store.getters['auth/userCanStartVideoCall']
    },
    userId() {
      return this.$store.getters['auth/userId']
    },
    videoCalls() {
      return this.calls.filter(isVideoCall)
    },
    voiceCalls() {
      return this.calls.filter(call => !isVideoCall(call))
    },
  },
  created() {
    this.getCalls()
  },
  methods: {
    isVideoCall,
    avatarText(text) {
      return avatarText(text)
    },
    call(id) {
      this.loading = true
      if (!this.store.getters['auth/userPhoneNumber']) {
        this.$store.dispatch('app/setModalAddPhoneNumberShowDiamond', false)
        this.$store.dispatch('app/setModalAddPhoneNumber', true)
        this.$store.dispatch('app/setVerificationType', 'phone')
      } else {
        useJwt.callUser(id)
          .then(() => {
            showNotify(this.$toast, this.$t('Calling successful'), 'success')
          })
          .catch(error => {
            const { response } = error
            throwDefaultError(this.$toast, error)
            if (response && response.data?.header?.error?.errorCode == 215) {
              this.$store.dispatch('app/setModalAddPhoneNumberShowDiamond', false)
              this.$store.dispatch('app/setModalAddPhoneNumber', true)
              this.$store.dispatch('app/setVerificationType', 'phone')
            }
          })
          .finally(() => { this.loading = false })
      }
    },
    getCalls() {
      this.loading = true
      useJwt.getCallHistory(0, this.limit)
        .then(response => {
          try {
            this.$nextTick(() => {
              // const incomingCalls = response.data.body.phoneCallsAnswered.map(incomingCall => {
              //   return {
              //     type: 'incoming',
              //     user: {
              //       userId: incomingCall.fromUserId,
              //       userName: incomingCall.fromUserName,
              //       profileImage: incomingCall.fromProfileImage,
              //     },
              //     time: incomingCall.callStartedAt,
              //     duration: incomingCall.callDurationInSeconds,
              //     callStatus: incomingCall.callStatus,
              //     callType: incomingCall.callType,
              //     userStatus: incomingCall.toUserOnlineStatus,
              //   }
              // })
              // const outgoingCalls = response.data.body.phoneCallsMade.map(outgoingCall => {
              //   return {
              //     type: 'outgoing',
              //     user: {
              //       userId: outgoingCall.toUserId,
              //       userName: outgoingCall.toUserName,
              //       profileImage: outgoingCall.toProfileImage,
              //     },
              //     time: outgoingCall.callStartedAt,
              //     duration: outgoingCall.callDurationInSeconds,
              //     callStatus: outgoingCall.callStatus,
              //     callType: outgoingCall.callType,
              //     userStatus: outgoingCall.toUserOnlineStatus,
              //   }
              // })
              //
              // this.calls = [...incomingCalls, ...outgoingCalls]

              this.successCalls = response.data.body.successCalls.map(call => {
                return {
                  ...call,
                  type: call.fromUuid === this.userId ? 'outgoing' : 'incoming',
                  user: {
                    userId: call.fromUuid === this.userId ? call.toUuid : call.fromUuid,
                    userName: call.fromUuid === this.userId ? call.toUserName : call.fromUserName,
                    profileImage: call.fromUuid === this.userId ? call.toProfileImage : call.fromProfileImage,
                  },
                  time: call.callStartedAt,
                  duration: call.callDurationInSeconds,
                  callStatus: call.callStatus,
                  callType: call.callType,
                  userStatus: call.fromUuid === this.userId ? call.toOnlineStatus : call.fromOnlineStatus,
                }
              })

              console.log('this.successCalls', this.successCalls)

              this.failedCalls = response.data.body.failedCalls.map(call => {
                return {
                  ...call,
                  type: call.fromUuid === this.userId ? 'outgoing' : 'incoming',
                  user: {
                    userId: call.fromUuid === this.userId ? call.toUuid : call.fromUuid,
                    userName: call.fromUuid === this.userId ? call.toUserName : call.fromUserName,
                    profileImage: call.fromUuid === this.userId ? call.toProfileImage : call.fromProfileImage,
                  },
                  time: call.callStartedAt,
                  duration: call.callDurationInSeconds,
                  callStatus: call.callStatus,
                  callType: call.callType,
                  userStatus: call.fromUuid === this.userId ? call.toOnlineStatus : call.fromOnlineStatus,
                }
              })

              console.log('this.failedCalls', this.failedCalls)

              this.calls = [...this.successCalls, ...this.failedCalls]

              console.log('this.calls', this.calls)
            })
          } catch (e) {
            throwDefaultError(this.$toast)
          }
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    getDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    resolveUserTypeVariant(type) {
      if (type === 'incoming') return 'warning'
      return 'primary'
    },
    resolveUserStatusVariant(type) {
      if (type === 'completed') return 'secondary'
      return 'success'
    },
    setLoading($event) {
      this.loading = $event
    },
  },
}
</script>
